module.exports = __webpack_public_path__ + "static/media/girl-binoculars.8e4dfdc5.jpg";